
const apiConfig = {
           baseURL: "https://api.b2win.site",
            //  baseURL: "http://localhost:5000",
};

export default apiConfig;